module.exports = __webpack_public_path__ + "static/media/wns.619bfb65.svg";